<div class="background-box shadow-box {{ classDiv }}">
  <h4 *ngIf="!!title" [className]="titleClass">{{ title }}</h4>
  <p *ngIf="!!desc" [className]="descClass">{{ desc }}</p>
  <ng-content></ng-content>
</div>
